(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["join-the-signal"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('.join-signal-form');
  if (form) {
    form.addEventListener('submit', function () {
      setTimeout(() => {
        const popup = document.createElement('div');
        popup.className = 'signal-success-popup';
        popup.innerHTML = `
          <h3>SIGNAL RECEIVED</h3>
          <p>You’re now part of the echo.</p>
        `;
        document.body.appendChild(popup);
        setTimeout(() => {
          popup.remove();
        }, 3000);
      }, 1000);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
